import {type AnyPcbBakedNode, type IPcbLayoutNodesRuleSetsMap, createActionRecordAction} from "@buildwithflux/core";

/**
 * This action can either entirely remove PCB nodes from their UID, or "toggle" them by using a rule set with an !important rule.
 * If you want to toggle the PCB node, pass them as baked nodes in the `toggleBakedNodes` and the action will create/remove a rule set for it.
 */
export const removeNodes = createActionRecordAction(
    "removeNodes",
    (
        removeNodeUids: string[],
        toggleBakedNodes: AnyPcbBakedNode[] = [],
        updatedNodesRulesSetsMap: IPcbLayoutNodesRuleSetsMap = {},
    ) => {
        return {
            payload: {
                removeNodeUids,
                toggleBakedNodes,
                updatedNodesRulesSetsMap,
                canUndo: true,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,

                hasInheritedRules: false,
                hasInheritedCalculations: false,
                requiresDescendantRebake: false,
                requiresNetDescendantRebake: false,
            },
        };
    },
    "removed PCB layout nodes",
);
